import React from "react";
import { RouteHelper } from "@nf/common";
import SearchIcon from "../../../resources/icons/search.svg";
import styles from "./SearchInput.module.scss";
import { LinkWithLocale } from "../../../components";

export type TSearchButtonProps = {
  isSearchInputExpanded: boolean;
  onClick: () => void;
  isSearchPage: boolean;
};

export const SearchButton = ({
  isSearchInputExpanded,
  onClick,
  isSearchPage,
}: TSearchButtonProps) => {
  return !isSearchInputExpanded && isSearchPage ? (
    <button onClick={onClick} className={styles.searchButton}>
      <SearchIcon className={styles.searchIcon} />
    </button>
  ) : (
    <LinkWithLocale href={RouteHelper.goToSearch("")}>
      <a>
        <SearchIcon className={styles.searchIcon} />
      </a>
    </LinkWithLocale>
  );
};
